"use strict";

exports.__esModule = true;
var _DeviceMTCDataQueryController = require("./DeviceMTCDataQueryController");
Object.keys(_DeviceMTCDataQueryController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMTCDataQueryController[key]) return;
  exports[key] = _DeviceMTCDataQueryController[key];
});